import type { DefaultTheme } from "styled-components";

export { default as PortfolioInvestmentCard } from "./PortfolioInvestmentCard.component";

/**
 * Asset classes carry a design-system badge tone rather than a fixed pair of
 * colours, so the tag follows light and dark.
 */
export const assetClassStyles = {
  "Fixed Income": "successSubtle",
  "Private Equity": "neutral",
  "Real Estate": "premium",
  "Venture Capital": "info",
  Others: "neutral",
} as const;

export type AssetClass = keyof typeof assetClassStyles;

export const assetClassBadge = (
  theme: DefaultTheme,
  assetClass?: string | null
): { background: string; text: string } =>
  theme.colors.domainSpecific.badgeTypes[
    assetClassStyles[(assetClass as AssetClass) ?? "Others"] ??
      assetClassStyles.Others
  ];
